<template>
  <div class="evaluation-content" >

  <!-- <v-row no-gutters class="roma-pagination d-flex  align-center justify-end">
    <Pagination 
          :pages="evaluations()[0].totalPages + 1"
          :getData="fetchEvaluations"
          :params="this.params"
        />
  </v-row> -->
  <div v-if="evaluations().length !== 0 && !loading()">
    <v-row>
      <div v-for="(evaluation, i) in evaluations()" :key="i">
        <div          
            v-if="evaluation.perfilAcceso === 1 || evaluation.perfilAcceso === null"            
            style="padding: 12px; width: 378px; height:293px"
          >
            <EvaluationCard  :evaluation="evaluation" />
        </div>
      </div>
      
    </v-row>
    <v-row class="roma-pagination d-flex  align-center justify-end">
       <v-pagination
        color="#743085"
        v-model="pageCurrent"
        @change="change"
        :length="numberPages()"
        total-visible="5"
      />
      <!--
        <v-select
          :items="numberPages()"
          item-text="label"
          item-value="index"
          rounded
          @change="change"
          dense
          color="white"
          :label="pageLabel"
          v-model="pageCurrent"
          solo
          class="select-pagination"
        ></v-select>
        <v-btn
          icon
          color="gray"
          @click="previous()"
          :disabled="disablingPrev"
          title="Anterior"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn
          icon
          color="gray"
          @click="next()"
          :disabled="disablingNext"
          title="Siguiente"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        -->
     </v-row>
  </div>
    

    <div class="px-3" v-if="evaluations().length == 0 && !loading()">
      <v-row>
          <v-col cols="12" class="d-flex align-items-center info-box parrafo-2">
            <v-icon color="#D8D7D9" class="mr-2">mdi-information-outline</v-icon>  No se han encontrado evaluaciones
          </v-col>
      </v-row>
    </div>
    <div class="d-flex justify-content-center pt-5" v-if="loading()">
        <v-progress-circular indeterminate color="#743085"></v-progress-circular>
        <v-progress-circular class="mx-2" indeterminate color="#E67F24"></v-progress-circular>
        <v-progress-circular class="mr-2" indeterminate color="#389CC3"></v-progress-circular>
        <v-progress-circular indeterminate color="#FADF2C"></v-progress-circular>
    </div>
  </div>
  
</template>

<script>
import EvaluationCard from "@/components/evaluations/EvaluationCard";
import { mapActions, mapGetters } from "vuex";
// import Pagination from "../commons/Pagination.vue";

export default {
  props: ["items"],
  data() {
    return {
      filter: null,
      pageCurrent: 1,
      pageLabel: "1",
      disableNext: false,
      disablePrev: false,
      totalPages: null
    };
  },
  components: {
    EvaluationCard,
    // Pagination
  },
  watch: {
    pageCurrent: {
        immediate: true,
        handler(value) {
          if(this.pageCurrent != value)
            this.change();
        }
    },
  },
  computed: {
    disablingNext() {
      console.log(this.totalPages)
      const disable =
        this.totalPages <= 1 ||
        this.totalPages === this.pageCurrent + 1;
      return disable;
    },
    disablingPrev() {
      const disable = this.pageCurrent === 0;
      return disable;
    },
    },
  methods: {
    ...mapActions({
      fetchEvaluations: "fetchEvaluations",
    }),
    ...mapGetters({
      evaluations: "getEvaluations",
      institucionId: "getInstitutionId",
      user: "getUserData",
      loading: "getLoading"
    }),
    filterEvaluations() {
      return this.fetchEvaluations();
    },
    numberPages(){
      const pages = [];
      this.totalPages =   this.evaluations()[0].totalPages
      for (let index = 0; index < this.totalPages; index++) {
        pages.push({ index: index, label: index + 1 });
      }
      return pages.length;
    },
    previous(){
      this.pageCurrent = this.pageCurrent - 1;
      this.change();

    },
    next(){
      this.pageCurrent = this.pageCurrent + 1;
      this.change();
    },
    change(){
        const { personId, section, institutionContext } = this.user();
        const params = {
          idInstitucion: this.institucionId(),
          idPersona: personId,
          idPeriodo: institutionContext.periodId,
          pageNumber: this.pageCurrent - 1,
          idEstado: [0,1]
        };
        this.fetchEvaluations(params);
    }
  },
  mounted() {
    const { personId, section, institutionContext } = this.user();
    const params = {
      idInstitucion: this.institucionId(),
      idPersona: personId,
      idPeriodo: institutionContext.periodId,
      pageNumber: 0,
      idEstado: [0,1]
    };
    this.fetchEvaluations(params);
  },
};
</script>

<style lang="scss">
.evaluation-content {
  // margin-top: 50px;
}
.select-pagination {
      max-width: 100px;
      .v-text-field__details {
        display: none;
      }
    }
</style>
